module.exports = __webpack_public_path__ + "img/banner-TV-1__md.c192c33c.jpg";